import { ExternalLink, Gauge, Wifi, Zap } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const FAST_URL = "https://fast.com/tr/";

export default function SpeedTest() {
  const { t } = useLang();

  return (
    <div
      data-testid="speed-test-widget"
      className="relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.06] p-6 backdrop-blur-2xl shadow-2xl shadow-black/30 sm:p-7"
    >
      <div className="pointer-events-none absolute -end-16 -top-16 h-40 w-40 rounded-full bg-[#2DD4BF]/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-16 -start-16 h-40 w-40 rounded-full bg-[#0891B2]/10 blur-3xl" />

      <div className="relative flex items-center gap-3">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-[#2DD4BF]/15 text-[#2DD4BF]">
          <Gauge className="h-5 w-5" />
        </span>
        <div>
          <p className="font-display text-lg font-bold text-white">{t("hero.speedTestTitle")}</p>
          <p className="text-xs text-zinc-400">{t("hero.speedTestDesc")}</p>
        </div>
      </div>

      <div className="relative mt-7 flex flex-col items-center text-center">
        <div className="relative flex h-32 w-32 items-center justify-center">
          <div className="absolute inset-0 rounded-full border-[6px] border-white/8" />
          <div
            className="absolute inset-0 rounded-full border-[6px] border-transparent border-t-[#2DD4BF] border-e-[#2DD4BF] animate-spin"
            style={{ animationDuration: "3s" }}
          />
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-[#0D9488] to-[#0891B2] text-white shadow-lg shadow-[#0D9488]/30">
            <Wifi className="h-7 w-7" strokeWidth={2.5} />
          </span>
        </div>
        <p className="mt-5 max-w-[240px] text-sm leading-relaxed text-zinc-400">
          {t("hero.speedTestNote")}
        </p>
      </div>

      <div className="mt-5 flex items-center justify-center gap-1.5 text-[11px] font-semibold text-zinc-500">
        <Zap className="h-3 w-3 text-[#2DD4BF]" />
        {t("hero.speedTestPoweredBy")}
      </div>

      <a
        href={FAST_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="speed-test-button"
        className="mt-5 flex h-12 w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-[#0D9488] to-[#0891B2] text-sm font-bold text-white transition-all hover:opacity-90 hover:shadow-lg hover:shadow-[#0D9488]/25"
      >
        {t("hero.speedTestLauncher")}
        <ExternalLink className="h-4 w-4" />
      </a>
    </div>
  );
}
